import { render, staticRenderFns } from "./MintalMesPrdSmeltingSubstationRecordEdit.vue?vue&type=template&id=2477b6f4&"
import script from "./MintalMesPrdSmeltingSubstationRecordEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSmeltingSubstationRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports